import React, { useMemo, useState } from "react";
import styles from "./card.module.scss";
import HoverCard from "./HoverCard";
import { LordIcon } from "@src/components/lord-icon/lord-icon";
import { IconInfo } from "@src/constants";
import IconStar from '@assets/icons/star_filled.svg?react'

type Props = {
  titleLine1: string;
  titleLine2?: string;
  mainIcon?: React.ReactNode;
  backGroundUrl?: string;
  imageUrl?: string;
  isComingSoon?: boolean;
  section?: string;
  hoverTitle?: string;
  hoverHint?: string;
  isSummary?: boolean;
  openCard?: () => void;
  className?: string;
  isTransition?: boolean;
  isFeatured?: boolean;
};

function ProgramCard(props: Props) {
  const {
    titleLine1,
    titleLine2,
    mainIcon,
    imageUrl,
    backGroundUrl,
    isComingSoon,
    section,
    hoverTitle,
    hoverHint,
    openCard,
    isSummary,
    isTransition = false,
    isFeatured = false,
  } = props;

  const isClassRoom = section === "Classroom";
  const [hover, setHover] = useState(false);

  const imageStyle = useMemo(() => {
    const classes = [''];
    if ( isSummary ) {
      classes.push(styles.summaryImageCard)
    } else if ( isTransition ) {
      classes.push(styles.transitionImageCard)
    } else {
      classes.push(styles.classroomImageCard)
    }
    if ( isComingSoon) {
      classes.push(styles.comingSoonImage)
    }
    return classes.join(' ');
  }, [isComingSoon, isSummary, isTransition])

  return (
    <div
      className={styles.programnCard}
      onClick={openCard}
      style={{ cursor: isComingSoon ? "default" : "pointer", pointerEvents: isComingSoon ? 'none': 'auto'}}
    >
      <div
        className={styles.background}
        style={{ backgroundImage: `url(${backGroundUrl})` }}
      ></div>
      <div className={styles.cardView}>
        <div
          className={`${styles.cardTitle}`}
          style={{ width: isClassRoom ? "46%" : "58%" }}
        >
          {mainIcon}
          <h2
            /* This is safe because this is not taking user input so not an injection risk,
               but it's necessary to render the <br/> element. */
            dangerouslySetInnerHTML={{ __html: titleLine1 }}
          ></h2>
          <h2
            style={{
              color: isComingSoon
                ? "#A0A0A0"
                : "#274649",
            }}
          >
            {titleLine2}
          </h2>
          {isFeatured && <div className={styles.featuredLabel}><IconStar /> Featured</div>}
          {isComingSoon && (
            <div className={styles.comingsoonLabel}>Coming Soon</div>
          )}
        </div>
        {imageUrl && (
          <div
            className={isTransition ? styles.transitionImageView : styles.classroomImageView}
          >
            <img
              src={imageUrl}
              alt="Play"
              className={imageStyle}
            />
          </div>
        )}
      </div>
      {hoverTitle && (
        <HoverCard
          title={hoverTitle || ""}
          hint={hoverHint || ""}
          releaseDate={""}
          isActive={hover}
          openCard={openCard}
        />
      )}

      {section !== "Profile" && (
        <div
          className={styles.iconWrapper}
          onMouseOver={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <LordIcon
            src={IconInfo}
            isHover={true}
            colors={{ primary: "#274649", secondary: "#274649" }}
            size={26}
          />
        </div>
      )}
    </div>
  );
}

export default ProgramCard;
